module.exports = __webpack_public_path__ + "img/m1.0f0623c7.png";